import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** ₹ with Indian digit grouping and no decimals. Accepts a numeric string or number. */
export function format_inr(value: string | number): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return `₹${value}`;
  return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}
